import React, { useState, useEffect } from "react";
import { Form, Col, Row, Button, Select, Input } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const PaymentMethodAddForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [paymentSelect, setPaymentSelect] = useState({
    data: [],
    loading: false,
  });
  const [form] = Form.useForm();

  useEffect(() => {
    getPaymentSets();
  }, []);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const getPaymentSets = () => {
    setPaymentSelect({ data: [], loading: true });

    RequestHandler.get(`/PaymentSet?$select=id,name`).then((res) => {
      setPaymentSelect({ data: res.value, loading: false });
    });
  };

  const onSuccess = () => {
    form.resetFields();
    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    RequestHandler.post(`/PaymentMethod`, values).then((response) => {
      setLoading(false);
      if (response?.success) {
        onSuccess();
      }
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  return (
    <Form
      {...formItemLayout}
      validateMessages={defaultValidateMessages}
      form={form}
      name="PaymentMethodAdd"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item
            label="Ödeme Şekli Adı"
            name="name"
            rules={[{ required: true }]}
          >
            <Input></Input>
          </Form.Item>

          <Form.Item name="paymentSetId" label="Ödeme Seti :">
            <Select
              allowClear
              showSearch
              placeholder="Varsayılan"
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={paymentSelect.loading}
            >
              {paymentSelect.data.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Row justify="space-between">
            <Col></Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Ekle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default PaymentMethodAddForm;
